"use client";
import useEmblaCarousel from "embla-carousel-react";
import { EmblaCarouselType } from "embla-carousel";
import React, { useCallback, useEffect, useState } from "react";

import styles from "./SmallCarousel.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.client";

interface SmallCarouselProps {
  children: React.ReactNode;
  extraClassName?: string;
}

export const SmallCarousel = ({
  children,
  extraClassName,
}: SmallCarouselProps) => {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    dragFree: true,
    align: "center",
  });
  const { getLabel, getIcon } = useGlobalContext();

  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return (
    <div className={`is-relative ${extraClassName || ""}`}>
      <div className={`${styles["embla-slider"]} embla-slider `} ref={emblaRef}>
        <ul className={`${styles["embla-container"]} embla-container`}>
          {children}
        </ul>
      </div>
      <button
        type="button"
        disabled={prevBtnDisabled}
        className={`${styles["embla-button-prev"]} embla-button-prev`}
        onClick={() => emblaApi?.scrollPrev()}
        aria-label={getLabel(
          "aria_label_nav_prev",
          "Rückwärts durch den Inhalt blättern",
        )}
      >
        <CustomSVG
          width={20}
          height={20}
          src={getIcon("arrowLeft")}
          wrapper={"span"}
          className="is-flex"
          aria-hidden
        />
      </button>
      <button
        type="button"
        disabled={nextBtnDisabled}
        className={`${styles["embla-button-next"]} embla-button-next`}
        onClick={() => emblaApi?.scrollNext()}
        aria-label={getLabel(
          "aria_label_nav_next",
          "Vorwärts durch den Inhalt blättern",
        )}
      >
        <CustomSVG
          width={20}
          height={20}
          src={getIcon("arrowRight")}
          wrapper={"span"}
          className="is-flex"
          aria-hidden
        />
      </button>
    </div>
  );
};
